<template>
    <StartpageHeroFrame />
    <VendorPaybackTeaserScoreboard />
    <StartpageAvatar />
    <StartpageTeaserCategory />
    <LazyStartpageTeaserBrand hydrate-on-visible />
    <StartpageRecommendationSponsored />
    <LazyStartpageRecommendation hydrate-on-visible />
    <LazyStartpageTeaserHighlight hydrate-on-visible />
    <LazyStartpageTeaserNewsletter hydrate-on-visible />
    <LazyStartpageStoreMessage hydrate-on-visible />
</template>